export const environment = {
  production: false,
  env: "Test",
  serverUrl: "https://test.cwmaintit.com/v1",
  mapBoxUrl: "https://api.mapbox.com/geocoding/v5/mapbox.places",
  mapBoxToken: "pk.eyJ1IjoiZGhzZW5zZWkiLCJhIjoiY2s3bTg0cGt2MDB4ZDNscGNlbGFhNGYyYiJ9.gasbmmixfK9Vfry149FMDQ",
  sentryEnable: false,
  sentryDsn: "https://4cec6d64261543aeafa1111aa362441d@o960623.ingest.sentry.io/5908975",
  sentryTraceOrigins: ["https://test.cwmaint.com", "https://test.itdivest.relutech.com"],
  logoutInactivity: 60 * 60,
  logoutTimeRemainingResponse: 60 * 5,
  logoutSilentRefresh: 60 * 10,
  /** if access token remaining seconds is < jwtApplyRefreshDelta, the token will be renewed */
  jwtApplyRefreshDelta: 60 * 30,
  zendeskApi: "https://channelworks1629117020.zendesk.com/api/v2",
  relutechUrl: "test.itdivest.relutech.com",
  mapboxLocationPageSize: 5,
  disabledPaths: [],
  luckyOrangeUrl: null,
  supportEmail: "example@mail.com",
};
